import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Template from '../components/templates/default';
import { sendMetricsEvent } from '../helpers';

const NotfoundPage = () => {
  const pageTitle = 'Página não encontrada - Experimente';

  useEffect(() => {
    sendMetricsEvent({
      eventName: pageTitle,
      pageview: true
    });
  }, []);
  return (
    <Template>
      <Helmet title={pageTitle} />
      <div>Página não encontrada</div>
    </Template>
  );
};

export default NotfoundPage;
